import React from "react";
import { Link } from "react-router-dom";

const Navbar = () => {
  return (
    <nav className="navbar navbar-light navbar-glass navbar-top navbar-expand">
      <button
        className="btn navbar-toggler-humburger-icon navbar-toggler me-1 me-sm-3"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarVerticalCollapse"
        aria-controls="navbarVerticalCollapse"
        aria-expanded="false"
        aria-label="Toggle Navigation"
      >
        <span className="navbar-toggle-icon">
          <span className="toggle-line" />
        </span>
      </button>
      <Link to="/" className="navbar-brand me-1 me-sm-3" href="index.html">
        <div className="d-flex align-items-center">
          <span className="font-sans-serif">صنعتبان</span>
        </div>
      </Link>
      <ul className="navbar-nav align-items-center d-none d-lg-block">
        <li className="nav-item">
          <div className="search-box" data-list='{"valueNames":["title"]}'>
            <div className="dropdown-menu border font-base start-0 mt-2 py-0 overflow-hidden w-100">
              <div
                className="scrollbar list py-3"
                style={{ maxHeight: "24rem" }}
              >
                <h6 className="dropdown-header fw-medium text-uppercase px-card fs--2 pt-0 pb-2">
                  اخیراً مرور شده است
                </h6>
                <a
                  className="dropdown-item fs--1 px-card py-1 hover-primary"
                  href="app/events/event-detail.html"
                >
                  <div className="d-flex align-items-center">
                    <svg
                      className="svg-inline--fa fa-circle fa-w-16 me-2 text-300 fs--2"
                      aria-hidden="true"
                      focusable="false"
                      data-prefix="fas"
                      data-icon="circle"
                      role="img"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 512 512"
                      data-fa-i2svg
                    >
                      <path
                        fill="currentColor"
                        d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z"
                      />
                    </svg>
                    {/* <span class="fas fa-circle me-2 text-300 fs--2"></span> Font Awesome fontawesome.com */}
                    <div className="fw-normal title">
                      صفحات
                      <svg
                        className="svg-inline--fa fa-chevron-left fa-w-10 mx-1 text-500 fs--2"
                        data-fa-transform="shrink-2"
                        aria-hidden="true"
                        focusable="false"
                        data-prefix="fas"
                        data-icon="chevron-left"
                        role="img"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 320 512"
                        data-fa-i2svg
                        style={{ transformOrigin: "0.3125em 0.5em" }}
                      >
                        <g transform="translate(160 256)">
                          <g transform="translate(0, 0)  scale(0.875, 0.875)  rotate(0 0 0)">
                            <path
                              fill="currentColor"
                              d="M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z"
                              transform="translate(-160 -256)"
                            />
                          </g>
                        </g>
                      </svg>
                      {/* <span class="fas fa-chevron-left mx-1 text-500 fs--2" data-fa-transform="shrink-2"></span> Font Awesome fontawesome.com */}
                      مناسبت ها
                    </div>
                  </div>
                </a>
                <a
                  className="dropdown-item fs--1 px-card py-1 hover-primary"
                  href="app/e-commerce/customers.html"
                >
                  <div className="d-flex align-items-center">
                    <svg
                      className="svg-inline--fa fa-circle fa-w-16 me-2 text-300 fs--2"
                      aria-hidden="true"
                      focusable="false"
                      data-prefix="fas"
                      data-icon="circle"
                      role="img"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 512 512"
                      data-fa-i2svg
                    >
                      <path
                        fill="currentColor"
                        d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z"
                      />
                    </svg>
                    {/* <span class="fas fa-circle me-2 text-300 fs--2"></span> Font Awesome fontawesome.com */}
                    <div className="fw-normal title">
                      تجارت الکترونیک
                      <svg
                        className="svg-inline--fa fa-chevron-left fa-w-10 mx-1 text-500 fs--2"
                        data-fa-transform="shrink-2"
                        aria-hidden="true"
                        focusable="false"
                        data-prefix="fas"
                        data-icon="chevron-left"
                        role="img"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 320 512"
                        data-fa-i2svg
                        style={{ transformOrigin: "0.3125em 0.5em" }}
                      >
                        <g transform="translate(160 256)">
                          <g transform="translate(0, 0)  scale(0.875, 0.875)  rotate(0 0 0)">
                            <path
                              fill="currentColor"
                              d="M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z"
                              transform="translate(-160 -256)"
                            />
                          </g>
                        </g>
                      </svg>
                      {/* <span class="fas fa-chevron-left mx-1 text-500 fs--2" data-fa-transform="shrink-2"></span> Font Awesome fontawesome.com */}
                      مشتریان
                    </div>
                  </div>
                </a>
                <hr className="bg-200 dark__bg-900" />
                <h6 className="dropdown-header fw-medium text-uppercase px-card fs--2 pt-0 pb-2">
                  فیلتر پیشنهادی
                </h6>
                <a
                  className="dropdown-item px-card py-1 fs-0"
                  href="app/e-commerce/customers.html"
                >
                  <div className="d-flex align-items-center">
                    <span className="badge fw-medium text-decoration-none me-2 badge-soft-warning">
                      مشتریان:
                    </span>
                    <div className="flex-1 fs--1 title">لیست همه مشتریان</div>
                  </div>
                </a>
                <a
                  className="dropdown-item px-card py-1 fs-0"
                  href="app/events/event-detail.html"
                >
                  <div className="d-flex align-items-center">
                    <span className="badge fw-medium text-decoration-none me-2 badge-soft-success">
                      مناسبت ها:
                    </span>
                    <div className="flex-1 fs--1 title">
                      آخرین رویدادهای ماه جاری
                    </div>
                  </div>
                </a>
                <a
                  className="dropdown-item px-card py-1 fs-0"
                  href="app/e-commerce/product/product-grid.html"
                >
                  <div className="d-flex align-items-center">
                    <span className="badge fw-medium text-decoration-none me-2 badge-soft-info">
                      محصولات:
                    </span>
                    <div className="flex-1 fs--1 title">محبوب ترین محصولات</div>
                  </div>
                </a>
                <hr className="bg-200 dark__bg-900" />
                <h6 className="dropdown-header fw-medium text-uppercase px-card fs--2 pt-0 pb-2">
                  فایل ها
                </h6>
                <a className="dropdown-item px-card py-2" href="#!">
                  <div className="d-flex align-items-center">
                    <div className="file-thumbnail me-2">
                      <img
                        className="border h-100 w-100 fit-cover rounded-3"
                        src="assets/img/products/3-thumb.png"
                        alt
                      />
                    </div>
                    <div className="flex-1">
                      <h6 className="mb-0 title">آیفون</h6>
                      <p className="fs--2 mb-0 d-flex">
                        <span className="fw-semi-bold">آنتونی</span>
                        <span className="fw-medium text-600 ms-2">
                          27 شهریور ساعت 10:30 صبح
                        </span>
                      </p>
                    </div>
                  </div>
                </a>
                <a className="dropdown-item px-card py-2" href="#!">
                  <div className="d-flex align-items-center">
                    <div className="file-thumbnail me-2">
                      <img
                        className="img-fluid"
                        src="assets/img/icons/zip.png"
                        alt
                      />
                    </div>
                    <div className="flex-1">
                      <h6 className="mb-0 title">صنعتبان نسخه 1.8.2</h6>
                      <p className="fs--2 mb-0 d-flex">
                        <span className="fw-semi-bold">جان</span>
                        <span className="fw-medium text-600 ms-2">
                          30 شهریور ساعت 12:30 ب.ظ
                        </span>
                      </p>
                    </div>
                  </div>
                </a>
                <hr className="bg-200 dark__bg-900" />
                <h6 className="dropdown-header fw-medium text-uppercase px-card fs--2 pt-0 pb-2">
                  اعضا
                </h6>
                <a
                  className="dropdown-item px-card py-2"
                  href="pages/user/profile.html"
                >
                  <div className="d-flex align-items-center">
                    <div className="avatar avatar-l status-online me-2">
                      <img
                        className="rounded-circle"
                        src="assets/img/team/1.jpg"
                        alt
                      />
                    </div>
                    <div className="flex-1">
                      <h6 className="mb-0 title">آنا کارینینا</h6>
                      <p className="fs--2 mb-0 d-flex">هوش برتر</p>
                    </div>
                  </div>
                </a>
                <a
                  className="dropdown-item px-card py-2"
                  href="pages/user/profile.html"
                >
                  <div className="d-flex align-items-center">
                    <div className="avatar avatar-l me-2">
                      <img
                        className="rounded-circle"
                        src="assets/img/team/2.jpg"
                        alt
                      />
                    </div>
                    <div className="flex-1">
                      <h6 className="mb-0 title">آنتونی هاپکینز</h6>
                      <p className="fs--2 mb-0 d-flex">اعتماد مغز</p>
                    </div>
                  </div>
                </a>
                <a
                  className="dropdown-item px-card py-2"
                  href="pages/user/profile.html"
                >
                  <div className="d-flex align-items-center">
                    <div className="avatar avatar-l me-2">
                      <img
                        className="rounded-circle"
                        src="assets/img/team/3.jpg"
                        alt
                      />
                    </div>
                    <div className="flex-1">
                      <h6 className="mb-0 title">اما واتسون</h6>
                      <p className="fs--2 mb-0 d-flex">گوگل</p>
                    </div>
                  </div>
                </a>
              </div>
              <div className="text-center mt-n3">
                <p className="fallback fw-bold fs-1 d-none">
                  هیچ نتیجه ای یافت نشد.
                </p>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;
